import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  setWrapper: {
    padding: theme.spacing(0, 2, 2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1, 2),
    },
  },
  setHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    padding: '8px 0',
    gap: theme.spacing(1),
  },

  title: {
    ...theme.mixins.appEllipsis,
    marginRight: theme.spacing(1),
    fontWeight: 500,
    fontStyle: 'normal',
    color: theme.palette.grey[700],
    fontSize: 12,
    padding: theme.spacing(1, 0),
    transform: 'none',
  },
  controlPanel: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  setItemsListWrapper: {
    borderRadius: '10px',
    border: `1px solid ${theme.palette.border.main}`,
    overflow: 'hidden',
  },
  setItemsListFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: theme.spacing(1),
  },

  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
}));
